export default "__VITE_ASSET__CQ$XnfRM__"